import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/");
        } catch (err) {
            setError(formatApiError(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="max-w-md mx-auto px-4 sm:px-6 py-16" data-testid="login-page">
            <div className="border-2 border-ink p-8">
                <h1 className="font-serif text-3xl font-black">Welcome back</h1>
                <p className="mt-2 text-sm text-muted-foreground">Log in to manage your subscription preferences.</p>

                <form onSubmit={submit} className="mt-8 space-y-5">
                    <div>
                        <label className="font-mono text-[11px] uppercase tracking-wider block mb-1">Email</label>
                        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email"
                            className="w-full border border-ink px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-accent" />
                    </div>
                    <div>
                        <label className="font-mono text-[11px] uppercase tracking-wider block mb-1">Password</label>
                        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password"
                            className="w-full border border-ink px-3 py-2.5 text-sm focus:outline-none focus:ring-1 focus:ring-accent" />
                        <Link to="/forgot-password" data-testid="login-forgot" className="mt-2 inline-block font-mono text-[11px] uppercase tracking-wider text-accent link-underline">
                            Forgot password?
                        </Link>
                    </div>
                    {error && <p className="text-sm text-neg border border-neg p-3" data-testid="login-error">{error}</p>}
                    <button type="submit" disabled={loading} data-testid="login-submit"
                        className="w-full bg-ink text-white py-3 font-mono text-xs uppercase tracking-widest hover:bg-accent transition-colors duration-150 disabled:opacity-50">
                        {loading ? "Logging in…" : "Log in"}
                    </button>
                </form>

                <p className="mt-6 text-sm text-muted-foreground">
                    No account? <Link to="/register" className="text-accent link-underline">Subscribe free</Link>
                </p>
            </div>
        </div>
    );
}
